import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { IReportData } from '@/libs/LibsReporHelper';

/**
 * 系统设置模块
 *
 * @export
 * @interface ISystem
 */
export interface ISystem {
	systemResults: any;
	addDialog: IAddDialogue;
}
/**
 * 对话框数据结构
 *
 * @export
 * @interface IAddDialogue
 */
export interface IAddDialogue {
	/**
	 * 是否打开状态
	 *
	 * @type {boolean}
	 * @memberOf IAddDialogue
	 */
	open: boolean;
}

/** 系统设置模块store */
@Module({
	dynamic: true,
	store,
	name: 'system'
})
class ModuleSystem extends VuexModule {
	/** 系统字典 */
	public queryVO: any = {
		type: '',
		data: {}
	};

	/** mutation 系统字典 */
	@Mutation
	private QUERT_QUERTVO(payload: any): any {
		this.queryVO = payload;
	}

	/** 系统字典 */
	@Action
	public savequeryVO(payload: any): any {
		this.QUERT_QUERTVO(payload);
	}

	/** 规则配置 */
	public query: any = {
		type: '',
		data: {}
	};

	/** mutation 规则配置 */
	@Mutation
	private QUERT_QUERT(payload: any): any {
		this.query = payload;
	}

	/** 规则配置 */
	@Action
	public savequery(payload: any): any {
		this.QUERT_QUERT(payload);
	}

	/** 规则配置表头动态 */
	public lintList: any = [];

	/** mutation 系统字典 */
	@Mutation
	private QUERT_LINTLIST(payload: any): any {
		this.lintList = payload;
	}

	/** 系统字典 */
	@Action
	public savelintList(payload: any): any {
		this.QUERT_LINTLIST(payload);
	}

	/** 定时任务 */
	public timedTask: any = {};

	/** mutation 定时任务 */
	@Mutation
	private QUERT_TIMEDTASK(payload: any): any {
		this.timedTask = payload;
	}

	/** 定时任务 */
	@Action
	public saveTimedTask(payload: any): any {
		this.QUERT_TIMEDTASK(payload);
	}

	/** 异步任务 */
	public asyncTask: any = {};

	/** mutation 异步任务 */
	@Mutation
	private QUERT_ASYNCTASK(payload: any): any {
		this.asyncTask = payload;
	}

	/** 异步任务 */
	@Action
	public saveAsyncTask(payload: any): any {
		this.QUERT_ASYNCTASK(payload);
	}

	// ====================================================================================================================================

	/** 财务科目新增弹窗 */
	public addDialogStatus: IAddDialogue = {
		open: false
	};

	/** mutation 打开财务科目新增弹窗 */
	@Mutation
	private OPEN_ADDDIALOG(open: boolean): any {
		this.addDialogStatus.open = open;
	}

	/** 页面更新财务科目新增弹窗状态 */
	@Action
	public saveOpenAddDialogStatus(open: boolean): any {
		this.OPEN_ADDDIALOG(open);
	}

	/** 系统设置列表查询参数 */
	public systemList: any = {};

	/** 派发事件 mutation */
	@Mutation
	public REQUEST_EVENT(payload: any): any {
		this.systemList = payload;
	}

	/** 派发事件 action */
	@Action
	public categoryDataEvent(payload: any): any {
		this.REQUEST_EVENT(payload);
	}

	/** 需求等级数据 */
	public requireLevelsList: Array<IRequireLevel> = [];

	/** 需求等级数据 mutation */
	@Mutation
	public SAVE_REQUIRE_LEVELS_LIST(payload: Array<IRequireLevel>): any {
		this.requireLevelsList = payload;
	}

	/** 需求等级数据 action */
	@Action
	public saveRequireLevelsList(payload: Array<any>): any {
		this.SAVE_REQUIRE_LEVELS_LIST(payload);
	}

	/** 需求等级数据 LOCK */
	public requireLevelsListLock: boolean = false;

	/** 需求等级数据 mutation LOCK */
	@Mutation
	public SAVE_REQUIRE_LEVELS_LIST_LOCK(payload: boolean): any {
		this.requireLevelsListLock = payload;
	}

	/** 需求等级数据 action LOCK */
	@Action
	public saveRequireLevelsListLock(payload: boolean): any {
		this.SAVE_REQUIRE_LEVELS_LIST_LOCK(payload);
	}

	// ====================================================  字典表数据（合同提示信息） ===========================
	/** 字典表数据 */
	public dictionaryTableList: Array<IRequireLevel> = [];

	/** 字典表数据 mutation */
	@Mutation
	public SAVE_DICTIONARY_TABLE_LIST(payload: Array<IRequireLevel>): any {
		this.dictionaryTableList = payload;
	}

	/** 字典表数据 action */
	@Action
	public saveDictionaryTableList(payload: Array<any>): any {
		this.SAVE_DICTIONARY_TABLE_LIST(payload);
	}

	/** 字典表数据 Lock */
	public dictionaryTableListLock: boolean = false;

	/** 字典表数据 mutation Lock */
	@Mutation
	public SAVE_DICTIONARY_TABLE_LIST_LOCK(payload: boolean): any {
		this.dictionaryTableListLock = payload;
	}

	/** 字典表数据 action Lock */
	@Action
	public saveDictionaryTableListLock(payload: boolean): any {
		this.SAVE_DICTIONARY_TABLE_LIST_LOCK(payload);
	}

	// ============================  DS开关 =============================================
	public dsSwitchInfo: any = {};

	/** DS开关 mutation */
	@Mutation
	public SAVE_DS_SWITCH_INFO(payload: any): any {
		this.dsSwitchInfo = payload;
	}

	/** DS开关 action */
	@Action
	public saveDsSwitchInfo(payload: any = {}): any {
		this.SAVE_DS_SWITCH_INFO(payload);
	}

	// ============================  用途维护 =============================================
	public purposeBean: any = {};

	/** 财务科目对应关系维护请求参数数据 mutation */
	@Mutation
	public SAVE_PURPOSE_BEAN_LIST(payload: any): any {
		this.purposeBean = payload;
	}

	/** 财务科目对应关系维护请求参数数据 action */
	@Action
	public purposeBeanList(payload: any): any {
		this.SAVE_PURPOSE_BEAN_LIST(payload);
	}

	// ============================  财务科目对应关系维呼=============================================
	/** 系统报表数据 */
	public reportList: Map<string, IReportData> = new Map();

	/** 需求等级数据 mutation */
	@Mutation
	public SAVE_REPORT_LIST(payload: Map<string, IReportData>): any {
		this.reportList = payload;
	}

	/** 需求等级数据 action */
	@Action
	public saveReportList(payload: Map<string, IReportData>): any {
		this.SAVE_REPORT_LIST(payload);
	}

	// =========================================================================
	/** 财务科目对应关系维护请求参数 */
	public queryCondition: any = {};

	/** 财务科目对应关系维护请求参数数据 mutation */
	@Mutation
	public SAVE_QUERY_CONDITION_LIST(payload: any): any {
		this.queryCondition = payload;
	}

	/** 财务科目对应关系维护请求参数数据 action */
	@Action
	public queryConditionList(payload: any): any {
		this.SAVE_QUERY_CONDITION_LIST(payload);
	}

	// ============================= 预算科目对应关系维护 ============================================
	/**  */
	public relationBeanm: any = {};

	/** 模板配置请求参数数据 mutation */
	@Mutation
	public SAVE_RELATION_BEAN_DATE(payload: any): any {
		this.relationBeanm = payload;
	}

	/** 模板配置请求参数数据 action */
	@Action
	public relationBeanDate(payload: any): any {
		this.SAVE_RELATION_BEAN_DATE(payload);
	}

	// ============================= 模板配置 ============================================
	/**  */
	public messageTemplateBean: any = {};

	/** 模板配置请求参数数据 mutation */
	@Mutation
	public SAVE_QUERY_MESSAGE_LIST(payload: any): any {
		this.messageTemplateBean = payload;
	}

	/** 模板配置请求参数数据 action */
	@Action
	public messageTemplateBeanList(payload: any): any {
		this.SAVE_QUERY_MESSAGE_LIST(payload);
	}

	// ============================= 定时任务 ============================================
	public timedDate: any = {};

	/** 定时任务请求参数数据 mutation */
	@Mutation
	public SAVE_QUERY_TIME_LIST(payload: any): any {
		this.timedDate = payload;
	}

	/** 定时任务请求参数数据 action */
	@Action
	public timedDateList(payload: any): any {
		this.SAVE_QUERY_TIME_LIST(payload);
	}

	// ============================= 模板查询 ============================================
	public purchaseTemplateBean: any = {};

	/** 定时任务请求参数数据 mutation */
	@Mutation
	public SAVE_TEMPLATE_BEAN_LIST(payload: any): any {
		this.purchaseTemplateBean = payload;
	}

	/** 定时任务请求参数数据 action */
	@Action
	public purchaseTemplateBeanList(payload: any): any {
		this.SAVE_TEMPLATE_BEAN_LIST(payload);
	}

	public contractInformation: any = {};

	/** 定时任务请求参数数据 mutation */
	@Mutation
	public SAVE_CONTRACT_BEAN_LIST(payload: any): any {
		this.contractInformation = payload;
	}

	/** 定时任务请求参数数据 action */
	@Action
	public contractInformationlist(payload: any): any {
		this.SAVE_CONTRACT_BEAN_LIST(payload);
	}

	// ============================= 按金额配置审批节点 ============================================
	public queryBean: any = {};

	/** 按金额配置审批节点请求参数数据 mutation */
	@Mutation
	public SAVE_QUERY_BEAN_LIST(payload: any): any {
		this.queryBean = payload;
	}

	/** 按金额配置审批节点请求参数数据 action */
	@Action
	public queryBeanList(payload: any): any {
		this.SAVE_QUERY_BEAN_LIST(payload);
	}

	/** 国家地区数据 */
	public nationList: Array<INation> = [];

	/** 国家地区数据 mutation */
	@Mutation
	public SAVE_NATION_LIST(payload: Array<INation>): any {
		this.nationList = payload;
	}

	/** 国家地区数据 action */
	@Action
	public saveNationList(payload: Array<INation>): any {
		this.SAVE_NATION_LIST(payload);
	}

	/** 国家地区数据 Lock */
	public nationListLock: boolean = false;

	/** 国家地区数据 mutation */
	@Mutation
	public SAVE_NATION_LIST_LOCK(payload: boolean): any {
		this.nationListLock = payload;
	}

	/** 国家地区数据 action */
	@Action
	public saveNationListLock(payload: boolean): any {
		this.SAVE_NATION_LIST_LOCK(payload);
	}
	// ============================= 科目设置 ============================================

	public relationBean: any = {};

	/** 定时任务请求参数数据 mutation */
	@Mutation
	public SAVE_RELATION_BEAN_LIST(payload: any): any {
		this.relationBean = payload;
	}

	/** 定时任务请求参数数据 action */
	@Action
	public relationBeanList(payload: any): any {
		this.SAVE_RELATION_BEAN_LIST(payload);
	}

	// ============================= 审批金额授权配置 ============================================

	public commonApprovalAmountGrantConfigBean: any = {};

	/** 定时任务请求参数数据 mutation */
	@Mutation
	public SAVE_APPROVAL_AMOUNT_LIST(payload: any): any {
		this.commonApprovalAmountGrantConfigBean = payload;
	}

	/** 定时任务请求参数数据 action */
	@Action
	public approvalAmountGrant(payload: any): any {
		this.SAVE_APPROVAL_AMOUNT_LIST(payload);
	}

	// ============================= 授权审批HR中心成本中心 ============================================
	/** 授权审批HR中心成本中心查询数据 */
	public commonApprovalConfigBean: any = {};

	/** 授权审批HR中心成本中心请求参数数据 mutation */
	@Mutation
	public SAVE_APPROVAL_CONFIG_LIST(payload: any): any {
		this.commonApprovalConfigBean = payload;
	}

	/** 授权审批HR中心成本中心请求参数数据 action */
	@Action
	public commonApprovalConfig(payload: any): any {
		this.SAVE_APPROVAL_CONFIG_LIST(payload);
	}

	/** 授权审批HR中心成本中心添加配置参数 */
	public approvalConfigParams: any = {
		deptId: '', // 部门id
		deptName: '', // 部门名称
		hrCenter: '', // hr中心id
		hrCenterName: '', // hr中心
		costCenterName: '', // 成本中心id
		costCenter: '', // 成本中心名称
		agentId: '', // 授权人id
		agentName: '', //  授权人名字
		createBy: '',
		createByName: '',
		createTime: '',
		updateBy: '',
		updateByName: '',
		updateTime: '',
		id: ''
	};

	/** 授权审批HR中心成本中心添加配置参数 mutation */
	@Mutation
	public SAVE_APPROVAL_CONFIG_PARAMS(payload: any): any {
		this.approvalConfigParams = payload;
	}

	/** 授权审批HR中心成本中心添加配置参数 action */
	@Action
	public appConfigParamseven(payload: any): any {
		this.SAVE_APPROVAL_CONFIG_PARAMS(payload);
	}

	// ============================= 字典表配置 ============================================

	public dictionaryBean: any = {};

	/** 定时任务请求参数数据 mutation */
	@Mutation
	public SAVE_DICTONARY_LIST(payload: any): any {
		this.dictionaryBean = payload;
	}

	/** 定时任务请求参数数据 action */
	@Action
	public dictionaryBeanDate(payload: any): any {
		this.SAVE_DICTONARY_LIST(payload);
	}

	// ============================= 供应商账号设置 ============================================

	// public query: any = {};

	// /** 供应商账号设置参数数据 mutation */
	// @Mutation
	// public SAVE_QUERY_LIST(payload: any): any {
	// 	this.query = payload;
	// }

	// /** 供应商账号设置参数数据 action */
	// @Action
	// public queryDate(payload: any): any {
	// 	this.SAVE_QUERY_LIST(payload);
	// }

	public selectionList: any = [];

	/** 供应商账号设置参数数据 mutation */
	@Mutation
	public SAVE_SELECTION_LIST(payload: any): any {
		this.selectionList = payload;
	}

	/** 供应商账号设置参数数据 action */
	@Action
	public selectionListData(payload: any): any {
		this.SAVE_SELECTION_LIST(payload);
	}

	// ================== 菜单栏的待办数量=============
	/** 首页菜单栏待办数量展示 */
	public todoList: any = {
		purchaseorderApproval: 0 // 订单我的待办
	};

	/** 首页菜单栏待办数量 Mutation */
	@Mutation
	private SET_TODO_LIST(todoList: any): any {
		this.todoList = todoList;
	}

	/** 首页菜单栏待办数量 Action */
	@Action
	public setTodoList(todoList: any): any {
		this.SET_TODO_LIST(todoList);
	}

	// ============================= 税码 ============================================
	/** 税码数据 */
	public taxtCodeList: Array<ITaxtCode> = [];

	/** 国家地区数据 mutation */
	@Mutation
	public SAVE_TAXTCODE_LIST(payload: Array<ITaxtCode>): any {
		this.taxtCodeList = payload;
	}

	/** 国家地区数据 action */
	@Action
	public saveTaxtCodeList(payload: Array<ITaxtCode>): any {
		this.SAVE_TAXTCODE_LIST(payload);
	}

	/** 税码数据LOADING */
	public taxtCodeListLoadingStatus: boolean = false;

	/** 国家地区数据 mutation LOADING */
	@Mutation
	public SAVE_TAXTCODE_LIST_LOADING_STATUS(payload: boolean): any {
		this.taxtCodeListLoadingStatus = payload;
	}

	/** 国家地区数据 action LOADING */
	@Action
	public saveTaxtCodeListLoadingList(payload: boolean): any {
		this.SAVE_TAXTCODE_LIST_LOADING_STATUS(payload);
	}

	// ============================= 币种 ============================================
	/** 币种数据 */
	public currencyList: Array<INation> = [];

	/** 币种数据 mutation */
	@Mutation
	public SAVE_CURRENCY_LIST(payload: Array<INation>): any {
		this.currencyList = payload;
	}

	/** 币种数据 action */
	@Action
	public saveCurrencyList(payload: Array<INation>): any {
		this.SAVE_CURRENCY_LIST(payload);
	}
}

/** 需求等级数据结构 */
export interface IRequireLevel {
	value?: string;
	label?: string;
	code?: string | undefined;
	desc?: string | undefined;
}

/** 国家地区数据结构 */
export interface INation {
	value?: number;
	label?: string;
}

/** 税码 */
export interface ITaxtCode {
	value?: string;
	code?: string;
}

/** 币种 */
export interface ICurrency {
	value?: number;
	label?: string;
}

/** document hooks */
export const systemModule: ModuleSystem = getModule(ModuleSystem);
